/**
 * @Description 冲突情况
 */
import V2Table from '@/common/components/Data/V2Table';
import V2Title from '@/common/components/Feedback/V2Title';
import { FC } from 'react';
const ConflictTable:FC<any> = ({
  distanceType,
  conflictRegionItemResponseList
}) => {
  const defaultColumns: any[] = [
    {
      key: 'regionName',
      title: '门店/点位冲突',
      width: 456,
      render: (value) => <span className='c-f23'>{value}</span>
    },
    {
      key: 'applyUserName',
      title: '申请人',
      width: 303
    },
    {
      key: 'distance',
      title: distanceType || '距离',
      render: (value) => `${value}m`,
      // width: 167
    },
  ];
  const loadData = () => {
    return {
      dataSource: conflictRegionItemResponseList.map((item, index) => ({
        ...item,
        id: index
      })),
      count: conflictRegionItemResponseList?.length,
    };
  };
  return <div className='mt-16'>
    <V2Title divider type='H2' text='冲突情况'/>
    <V2Table
      rowKey='id'
      defaultColumns={defaultColumns}
      voluntarilyEmpty
      onFetch={loadData}
      pagination={false}
      hideColumnPlaceholder
      className='mt-8 mb-16'
    />
  </div>;
};
export default ConflictTable;
